import { css } from '@emotion/css';

export const canvas = (width) => css`
  label: cluster-legend-canvas;
  width: ${width};
`;
